import { Component } from '@angular/core';
import { BaseAdvancedPropertyViewComponent } from '../base-advanced-property-view.component';
import { PodestComponent } from 'src/app/models/components/commonComponents/PodestComponent';
import { getComponentFromSource } from 'src/app/generics-helper/getComponentFromSource.generic';
import { ComponentNames } from 'src/app/helper/componentNames';
import { MatDialogRef } from '@angular/material/dialog';
import { InputHelper } from 'src/app/helper/inputHelper';

@Component({
  selector: 'app-overheadstorage',
  templateUrl: './overheadstorage.component.html',
  styleUrls: ['./overheadstorage.component.css']
})
export class OverheadStorageViewComponent extends BaseAdvancedPropertyViewComponent {
  podest: PodestComponent;
  integerOnly = InputHelper.integerOnly;

  constructor(public dialogRef: MatDialogRef<BaseAdvancedPropertyViewComponent>) {
    super(dialogRef);
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.podest = getComponentFromSource(ComponentNames.podestComponent, this.items);
  }

  saveButtonDisabledState(): boolean {
    return false;
  }
}
